import React, { createRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { SketchPicker } from 'react-color';
import { useDispatch, useSelector } from 'react-redux';
import { t } from 'i18next';
import { CircularProgress } from '@mui/material';
import {
  PlusIcon,
  DeleteTemplateIcon,
  EditTemplateIcon,
  Accordion,
} from '../../../shared/component/svgIcon';
import templates from '../../../utils/api/templates';
import SelectBoxNew from '../../../shared/component/form/SelectBoxNew';
import { updateCurrentTemplate } from '../../../redux/slices/TemplateSlice';
import { setErrorNotification } from '../../../redux/slices/NotificationSlice';

function StyleTemplateEditor({ setNewData }) {
  const template = useSelector((state) => state?.currentTemplate?.templateContent);
  const localDataRaw = sessionStorage.getItem('templateEditData');
  const localData = localDataRaw ? JSON.parse(localDataRaw) : null;

  const updatedData = Object.keys(template || {}).length ? template : localData;
  const dispatch = useDispatch();
  const [arr, setArr] = useState(updatedData);
  const [openIndex, setOpenIndex] = useState(null);
  // const [imageRefs] = useState(template?.template_images?.map(() => createRef()));
  const [imageRefs, setImageRefs] = useState(() => (template?.template_images || []).map(() => createRef()));
  useEffect(() => {
    if (template?.template_images?.length) {
      setImageRefs(template?.template_images?.map(() => createRef()));
    }
  }, [template]);
  useEffect(() => {
    setArr(updatedData);
  }, [template, localData]);
  useEffect(() => {
    setNewData([arr]);
    dispatch(updateCurrentTemplate(arr));
  }, [arr]);
  const [selectedMtFont, setSelectedMtFont] = useState(arr?.styles.title_style?.fontFamily);
  const [selectedMstFont, setSelectedMstFont] = useState(arr?.styles?.sub_title_style
    ? arr?.styles?.sub_title_style?.fontFamily : '');
  const [selectedCmFont, setSelectedCmFont] = useState(arr?.styles?.cate_style
    ? arr?.styles?.cate_style?.fontFamily : '');
  const [selectedInFont, setSelectedInFont] = useState(arr?.styles?.item_style
    ? arr?.styles?.item_style?.fontFamily : '');
  const [selectedIdFont, setSelectedIdFont] = useState(arr?.styles?.desc_style
    ? arr?.styles?.desc_style?.fontFamily : '');
  const [selectedIphFont, setSelectedIphFont] = useState(arr?.styles?.price_header_style
    ? arr?.styles?.price_header_style?.fontFamily : '');
  const [selectedIpFont, setSelectedIpFont] = useState(arr?.styles?.price_style
    ? arr?.styles?.price_style?.fontFamily : '');

  const fontStyles = ['Arial',
    'Helvetica',
    'Times New Roman',
    'Courier New',
    'Verdana',
    'Georgia',
    'Palatino',
    'Garamond',
    'Bookman',
    'Comic Sans MS',
    'sans-serif',
    'Trebuchet MS',
    'Arial Black',
    'Impact',
    'Lucida Console'];
  const [isMenuTitleOpen, setMtIsOpen] = useState(false);
  const [isMstOpen, setMstIsOpen] = useState(false);
  const [isCmOpen, setCmIsOpen] = useState(false);
  const [isInOpen, setInIsOpen] = useState(false);
  const [isIdOpen, setIdIsOpen] = useState(false);
  const [isIphOpen, setIphIsOpen] = useState(false);
  const [isIpOpen, setIpIsOpen] = useState(false);
  const [loading, setLoading] = useState('');

  const [MenuTitleColor, setMenuTitleColor] = useState(arr?.styles?.title_style
    ? arr?.styles?.title_style?.color : '#000000');
  const [MstColor, setMstColor] = useState(arr?.styles?.sub_title_style
    ? arr?.styles?.sub_title_style?.color : '#000000');
  const [CmColor, setCmColor] = useState(arr?.styles?.cate_style
    ? arr?.styles?.cate_style?.color : '#000000');
  const [InColor, setInColor] = useState(arr?.styles?.item_style
    ? arr?.styles?.item_style?.color : '#000000');
  const [IdColor, setIdColor] = useState(arr?.styles?.desc_style
    ? arr?.styles?.desc_style?.color : '#000000');
  const [IphColor, setIphColor] = useState(arr?.styles?.price_header_style
    ? arr?.styles?.price_header_style?.color : '#000000');
  const [IpColor, setIpColor] = useState(arr?.styles?.price_style
    ? arr?.styles?.price_style?.color : '#000000');

  const [selectedMtSize, setSelectedMtSize] = useState(arr?.styles?.title_style?.fontSize);
  const [selectedMstSize, setSelectedMstSize] = useState(arr?.styles?.sub_title_style
    ? arr?.styles?.sub_title_style?.fontSize : '');
  const [selectedCmSize, setSelectedCmSize] = useState(arr?.styles?.cate_style
    ? arr?.styles?.cate_style?.fontSize : '');
  const [selectedInSize, setSelectedInSize] = useState(arr?.styles?.item_style
    ? arr?.styles?.item_style?.fontSize : '');
  const [selectedIdSize, setSelectedIdSize] = useState(arr?.styles?.desc_style
    ? arr?.styles?.desc_style?.fontSize : '');
  const [selectedIphSize, setSelectedIphSize] = useState(arr?.styles?.price_header_style
    ? arr?.styles?.price_header_style?.fontSize : '');
  const [selectedIpSize, setSelectedIpSize] = useState(arr?.styles?.price_style
    ? arr?.styles?.price_style?.fontSize : '');

  const fontStylesTemplate2 = [
    'Montserrat', 'Big Shoulders Display',
    ...fontStyles,
  ];

  const fontStylesTemplate3 = [
    'Knewave', 'Luckiest Guy',
    'McLaren',
    ...fontStyles,
  ];

  const fontStylesTemplate4 = [
    'McLaren', 'Luckiest Guy',
    ...fontStyles,
  ];

  const fontStylesTemplate5 = [
    'Merienda', 'Inter',
    'Kaushan Script',
    ...fontStyles,
  ];
  const fontStylesTemplate8 = [
    'Montserrat',
    'Colus',
    ...fontStyles,
  ];
  const fontStylesTemplate9 = [
    'Nunito',
    'Playfair Display',
    ...fontStyles,
  ];
  const fontStylesTemplate10 = [
    'Paytone One',
    'Poppins',
    ...fontStyles,
  ];

  const templateFontMapping = {
    1: fontStyles,
    2: fontStylesTemplate2,
    3: fontStylesTemplate3,
    4: fontStylesTemplate4,
    5: fontStylesTemplate5,
    6: fontStyles,
    7: fontStyles,
    8: fontStylesTemplate8,
    9: fontStylesTemplate9,
    10: fontStylesTemplate10,
  };

  const getFontStyles = (templateNumber) => templateFontMapping[templateNumber] || [];

  // const handleMtSizeChange = (e) => {
  //   setSelectedMtSize(e.target.value);
  //   const newSize = e.target.value;
  //   setArr((prevState) => {
  //     // Make a copy of the styles object
  //     const updatedStyles = { ...prevState.styles };
  //     // Make a copy of the title_style object
  //     const updatedTitleStyle = { ...updatedStyles.title_style };
  //     // Update the fontSize property
  //     updatedTitleStyle.fontSize = newSize;
  //     // Update the title_style within the styles object
  //     updatedStyles.title_style = updatedTitleStyle;
  //     // Return the updated state object with the new styles
  //     return {
  //       ...prevState,
  //       styles: updatedStyles,
  //     };
  //   });
  // };

  const handleMtSizeChange = (selectedOption) => {
    const newSize = selectedOption?.label || '';

    setSelectedMtSize(newSize);
    setArr((prevState) => ({
      ...prevState,
      styles: {
        ...prevState.styles,
        title_style: {
          ...prevState.styles?.title_style,
          fontSize: newSize,
        },
      },
    }));
  };
  // const handleMstSizeChange = (e) => {
  //   setSelectedMstSize(e.target.value);
  //   const newSize = e.target.value;
  //   setArr((prevState) => {
  //     // Make a copy of the styles object
  //     const updatedStyles = { ...prevState?.styles };
  //     // Make a copy of the title_style object
  //     const updatedTitleStyle = { ...updatedStyles?.sub_title_style };
  //     // Update the fontSize property
  //     updatedTitleStyle.fontSize = newSize;
  //     // Update the title_style within the styles object
  //     updatedStyles.sub_title_style = updatedTitleStyle;
  //     // Return the updated state object with the new styles
  //     return {
  //       ...prevState,
  //       styles: updatedStyles,
  //     };
  //   });
  // };
  const handleMstSizeChange = (selectedOption) => {
    const newSize = selectedOption?.label || '';
    setSelectedMstSize(newSize);
    setArr((prevState) => ({
      ...prevState,
      styles: {
        ...prevState.styles,
        sub_title_style: {
          ...prevState.styles?.sub_title_style,
          fontSize: newSize,
        },
      },
    }));
  };
  // const handleCmSizeChange = (e) => {
  //   setSelectedCmSize(e.target.value);
  //   const newSize = e.target.value;
  //   setArr((prevState) => {
  //     // Make a copy of the styles object
  //     const updatedStyles = { ...prevState?.styles };
  //     // Make a copy of the title_style object
  //     const updatedTitleStyle = { ...updatedStyles?.cate_style };
  //     // Update the fontSize property
  //     updatedTitleStyle.fontSize = newSize;
  //     // Update the title_style within the styles object
  //     updatedStyles.cate_style = updatedTitleStyle;
  //     // Return the updated state object with the new styles
  //     return {
  //       ...prevState,
  //       styles: updatedStyles,
  //     };
  //   });
  // };
  const handleCmSizeChange = (selectedOption) => {
    const newSize = selectedOption?.label || '';

    setSelectedCmSize(newSize);
    setArr((prevState) => {
      const updatedStyles = { ...prevState?.styles };
      const updatedCateStyle = { ...updatedStyles?.cate_style };
      updatedCateStyle.fontSize = newSize;
      updatedStyles.cate_style = updatedCateStyle;

      return {
        ...prevState,
        styles: updatedStyles,
      };
    });
  };
  // const handleInSizeChange = (e) => {
  //   setSelectedInSize(e.target.value);
  //   const newSize = e.target.value;

  //   setArr((prevState) => {
  //     // Make a copy of the styles object
  //     const updatedStyles = { ...prevState?.styles };
  //     // Make a copy of the title_style object
  //     const updatedTitleStyle = { ...updatedStyles?.item_style };
  //     // Update the fontSize property
  //     updatedTitleStyle.fontSize = newSize;
  //     // Update the title_style within the styles object
  //     updatedStyles.item_style = updatedTitleStyle;

  //     // Return the updated state object with the new styles
  //     return {
  //       ...prevState,
  //       styles: updatedStyles,
  //     };
  //   });
  // };
  const handleInSizeChange = (selectedOption) => {
    const newSize = selectedOption?.label || '';

    setSelectedInSize(newSize);
    setArr((prevState) => {
      const updatedStyles = { ...prevState?.styles };
      const updatedItemStyle = { ...updatedStyles?.item_style };

      updatedItemStyle.fontSize = newSize;
      updatedStyles.item_style = updatedItemStyle;

      return {
        ...prevState,
        styles: updatedStyles,
      };
    });
  };
  // const handleIdSizeChange = (e) => {
  //   setSelectedIdSize(e.target.value);
  //   const newSize = e.target.value;

  //   setArr((prevState) => {
  //     // Make a copy of the styles object
  //     const updatedStyles = { ...prevState?.styles };
  //     // Make a copy of the title_style object
  //     const updatedTitleStyle = { ...updatedStyles?.desc_style };
  //     // Update the fontSize property
  //     updatedTitleStyle.fontSize = newSize;
  //     // Update the title_style within the styles object
  //     updatedStyles.desc_style = updatedTitleStyle;

  //     // Return the updated state object with the new styles
  //     return {
  //       ...prevState,
  //       styles: updatedStyles,
  //     };
  //   });
  // };
  const handleIdSizeChange = (selectedOption) => {
    const newSize = selectedOption?.id || '';

    setSelectedIdSize(newSize);
    setArr((prevState) => {
      const updatedStyles = { ...prevState?.styles };
      const updatedDescStyle = { ...updatedStyles?.desc_style };

      updatedDescStyle.fontSize = newSize;
      updatedStyles.desc_style = updatedDescStyle;

      return {
        ...prevState,
        styles: updatedStyles,
      };
    });
  };
  // const handleIphSizeChange = (e) => {
  //   setSelectedIphSize(e.target.value);
  //   const newSize = e.target.value;
  //   setArr((prevState) => {
  //     // Make a copy of the styles object
  //     const updatedStyles = { ...prevState?.styles };
  //     // Make a copy of the title_style object
  //     const updatedTitleStyle = { ...updatedStyles?.price_header_style };
  //     // Update the fontSize property
  //     updatedTitleStyle.fontSize = newSize;
  //     // Update the title_style within the styles object
  //     updatedStyles.price_header_style = updatedTitleStyle;
  //     // Return the updated state object with the new styles
  //     return {
  //       ...prevState,
  //       styles: updatedStyles,
  //     };
  //   });
  // };
  const handleIphSizeChange = (selectedOption) => {
    const newSize = selectedOption?.id || '';
    setSelectedIphSize(newSize);
    setArr((prevState) => {
      const updatedStyles = { ...prevState?.styles };
      const updatedPriceHeaderStyle = { ...updatedStyles?.price_header_style };
      updatedPriceHeaderStyle.fontSize = newSize;
      updatedStyles.price_header_style = updatedPriceHeaderStyle;
      return {
        ...prevState,
        styles: updatedStyles,
      };
    });
  };
  // const handleIpSizeChange = (e) => {
  //   setSelectedIpSize(e.target.value);
  //   const newSize = e.target.value;
  //   setArr((prevState) => {
  //     // Make a copy of the styles object
  //     const updatedStyles = { ...prevState?.styles };
  //     // Make a copy of the title_style object
  //     const updatedTitleStyle = { ...updatedStyles?.price_style };
  //     // Update the fontSize property
  //     updatedTitleStyle.fontSize = newSize;
  //     // Update the title_style within the styles object
  //     updatedStyles.price_style = updatedTitleStyle;
  //     // Return the updated state object with the new styles
  //     return {
  //       ...prevState,
  //       styles: updatedStyles,
  //     };
  //   });
  // };
  const handleIpSizeChange = (selectedOption) => {
    const newSize = selectedOption?.id || '';
    setSelectedIpSize(newSize);
    setArr((prevState) => ({
      ...prevState,
      styles: {
        ...prevState?.styles,
        price_style: {
          ...prevState?.styles?.price_style,
          fontSize: newSize,
        },
      },
    }));
  };
  const handleMenuTitleDivClick = () => {
    setMtIsOpen(!isMenuTitleOpen);
  };
  const handleMstDivClick = () => {
    setMstIsOpen(!isMstOpen);
  };
  const handleCmDivClick = () => {
    setCmIsOpen(!isCmOpen);
  };
  const handleInDivClick = () => {
    setInIsOpen(!isInOpen);
  };
  const handleIdDivClick = () => {
    setIdIsOpen(!isIdOpen);
  };
  const handleIphDivClick = () => {
    setIphIsOpen(!isIphOpen);
  };
  const handleIpDivClick = () => {
    setIpIsOpen(!isIpOpen);
  };

  const handleMenuTitleColorChange = (color) => {
    setMenuTitleColor(color?.hex);
    setArr((prevState) => ({
      ...prevState,
      styles: {
        ...prevState?.styles,
        title_style: {
          ...prevState?.styles?.title_style,
          color: color?.hex,
        },
      },
    }));
    setMtIsOpen(false);
  };
  const handleBlur = () => {
    setMtIsOpen(false);
  };
  const handleMstColorChange = (color) => {
    setMstColor(color?.hex);
    setArr((prevState) => ({
      ...prevState,
      styles: {
        ...prevState?.styles,
        sub_title_style: {
          ...prevState?.styles?.sub_title_style,
          color: color?.hex,
        },
      },
    }));
    setMstIsOpen(false);
  };
  const handleColorMst = () => {
    setMstIsOpen(false);
  };
  const handleCmColorChange = (color) => {
    setCmColor(color?.hex);
    // Close the color picker after selecting a color
    setArr((prevState) => ({
      ...prevState,
      styles: {
        ...prevState?.styles,
        cate_style: {
          ...prevState?.styles?.cate_style,
          color: color?.hex,
        },
      },
    }));
    setCmIsOpen(false);
  };
  const handleColorCm = () => {
    setCmIsOpen(false);
  };
  const handleInColorChange = (color) => {
    setInColor(color?.hex);
    // Close the color picker after selecting a color
    setArr((prevState) => ({
      ...prevState,
      styles: {
        ...prevState?.styles,
        item_style: {
          ...prevState?.styles?.item_style,
          color: color?.hex,
        },
      },
    }));
    setInIsOpen(false);
  };
  const handleColorIn = () => {
    setInIsOpen(false);
  };
  const handleIdColorChange = (color) => {
    setIdColor(color?.hex);
    setArr((prevState) => ({
      ...prevState,
      styles: {
        ...prevState?.styles,
        desc_style: {
          ...prevState?.styles?.desc_style,
          color: color?.hex,
        },
      },
    }));
    setIdIsOpen(false);
  };
  const handleColorId = () => {
    setIdIsOpen(false);
  };
  const handleIphColorChange = (color) => {
    setIphColor(color?.hex);
    // Close the color picker after selecting a color
    setArr((prevState) => ({
      ...prevState,
      styles: {
        ...prevState?.styles,
        price_header_style: {
          ...prevState?.styles?.price_header_style,
          color: color?.hex,
        },
      },
    }));
    setIphIsOpen(false);
  };
  const handleColorIph = () => {
    setIphIsOpen(false);
  };
  const handleIpColorChange = (color) => {
    setIpColor(color?.hex);
    // Close the color picker after selecting a color
    setArr((prevState) => ({
      ...prevState,
      styles: {
        ...prevState?.styles,
        price_style: {
          ...prevState?.styles?.price_style,
          color: color?.hex,
        },
      },
    }));
    setIpIsOpen(false);
  };

  const handleColorIp = () => {
    setIpIsOpen(false);
  };

  //   const handleMtFamilyChange = (e) => {
  //     setSelectedMtFont(e.target.value);
  //     const ff = e.target.value;
  //     setArr((prevState) => ({
  //       ...prevState,
  //       styles: {
  //         ...prevState?.styles,
  //         title_style: {
  //           ...prevState?.styles?.title_style,
  //           fontFamily: ff,
  //         },
  //       },
  //     }));
  //   };
  const handleMtFamilyChange = (selectedOption) => {
    const fontFamily = selectedOption?.label || '';
    setSelectedMtFont(fontFamily);
    setArr((prevState) => ({
      ...prevState,
      styles: {
        ...prevState?.styles,
        title_style: {
          ...prevState?.styles?.title_style,
          fontFamily,
        },
      },
    }));
  };
  // const handleMstFamilyChange = (e) => {
  //   setSelectedMstFont(e.target.value);
  //   const ff = e.target.value;
  //   setArr((prevState) => ({
  //     ...prevState,
  //     styles: {
  //       ...prevState?.styles,
  //       sub_title_style: {
  //         ...prevState?.styles?.sub_title_style,
  //         fontFamily: ff,
  //       },
  //     },
  //   }));
  // };
  const handleMstFamilyChange = (selectedOption) => {
    const fontFamily = selectedOption?.label || '';
    setSelectedMstFont(fontFamily);
    setArr((prevState) => ({
      ...prevState,
      styles: {
        ...prevState.styles,
        sub_title_style: {
          ...prevState.styles?.sub_title_style,
          fontFamily,
        },
      },
    }));
  };
  // const handleCmFamilyChange = (e) => {
  //   setSelectedCmFont(e.target.value);
  //   const ff = e.target.value;
  //   setArr((prevState) => ({
  //     ...prevState,
  //     styles: {
  //       ...prevState?.styles,
  //       cate_style: {
  //         ...prevState?.styles?.cate_style,
  //         fontFamily: ff,
  //       },
  //     },
  //   }));
  // };
  const handleCmFamilyChange = (selectedOption) => {
    const fontFamily = selectedOption?.label || '';

    setSelectedCmFont(fontFamily);
    setArr((prevState) => ({
      ...prevState,
      styles: {
        ...prevState.styles,
        cate_style: {
          ...prevState.styles?.cate_style,
          fontFamily,
        },
      },
    }));
  };
  // const handleInFamilyChange = (e) => {
  //   setSelectedInFont(e.target.value);
  //   const ff = e.target.value;
  //   setArr((prevState) => ({
  //     ...prevState,
  //     styles: {
  //       ...prevState?.styles,
  //       item_style: {
  //         ...prevState?.styles?.item_style,
  //         fontFamily: ff,
  //       },
  //     },
  //   }));
  // };
  const handleInFamilyChange = (selectedOption) => {
    const selectedFont = selectedOption?.label || '';
    setSelectedInFont(selectedFont);
    setArr((prevState) => ({
      ...prevState,
      styles: {
        ...prevState?.styles,
        item_style: {
          ...prevState?.styles?.item_style,
          fontFamily: selectedFont,
        },
      },
    }));
  };
  // const handleIdFamilyChange = (e) => {
  //   setSelectedIdFont(e.target.value);
  //   const ff = e.target.value;
  //   setArr((prevState) => ({
  //     ...prevState,
  //     styles: {
  //       ...prevState?.styles,
  //       desc_style: {
  //         ...prevState?.styles?.desc_style,
  //         fontFamily: ff,
  //       },
  //     },
  //   }));
  // };
  const handleIdFamilyChange = (selectedOption) => {
    const selectedFont = selectedOption?.label || '';
    setSelectedIdFont(selectedFont);
    setArr((prevState) => ({
      ...prevState,
      styles: {
        ...prevState?.styles,
        desc_style: {
          ...prevState?.styles?.desc_style,
          fontFamily: selectedFont,
        },
      },
    }));
  };
  // const handleIphFamilyChange = (e) => {
  //   setSelectedIphFont(e.target.value);
  //   const ff = e.target.value;
  //   setArr((prevState) => ({
  //     ...prevState,
  //     styles: {
  //       ...prevState?.styles,
  //       price_header_style: {
  //         ...prevState?.styles?.price_header_style,
  //         fontFamily: ff,
  //       },
  //     },
  //   }));
  // };
  const handleIphFamilyChange = (selectedOption) => {
    const fontFamily = selectedOption?.id || '';
    setSelectedIphFont(fontFamily);
    setArr((prevState) => ({
      ...prevState,
      styles: {
        ...prevState?.styles,
        price_header_style: {
          ...prevState?.styles?.price_header_style,
          fontFamily,
        },
      },
    }));
  };
  // const handleIpFamilyChange = (e) => {
  //   setSelectedIpFont(e.target.value);
  //   const ff = e.target.value;
  //   setArr((prevState) => ({
  //     ...prevState,
  //     styles: {
  //       ...prevState?.styles,
  //       price_style: {
  //         ...prevState?.styles?.price_style,
  //         fontFamily: ff,
  //       },
  //     },
  //   }));
  // };
  const handleIpFamilyChange = (selectedOption) => {
    const selectedFont = selectedOption?.id || '';

    setSelectedIpFont(selectedFont);
    setArr((prevState) => ({
      ...prevState,
      styles: {
        ...prevState?.styles,
        price_style: {
          ...prevState?.styles?.price_style,
          fontFamily: selectedFont,
        },
      },
    }));
  };
  const handleChangeBackgroundImage = (e, index) => {
    e.preventDefault();
    imageRefs[index]?.current?.click();
  };

  const handleFileChange = async (e, index) => {
    const file = e.target.files[0];
    const request = {
      'background-image': file,
    };
    setLoading(index);
    const isFromParent = sessionStorage.getItem('isFromParent') === 'true';
    const addFn = isFromParent
      ? templates.updateTemplateImageInCms
      : templates.updateTemplateImage;
    addFn(request).then((res) => {
      setLoading('');
      const newData = JSON.parse(JSON.stringify(arr));
      newData.template_images[index].image = res?.data?.background_image;
      setArr(newData);
    })
      .catch((error) => {
        setLoading('');
        dispatch(setErrorNotification(error?.response?.data));
      });
    e.target.value = '';
  };

  const removeBackgroundImage = (index) => {
    const updatedImages = [...arr.template_images]; // Create a copy of the original array
    const updatedObject = { ...updatedImages[index], image: null };
    // Replace keyToUpdate with the key you want to update
    updatedImages[index] = updatedObject; // Update the object at the specified index
    setArr((prevState) => ({
      ...prevState,
      template_images: updatedImages, // Set the state with the updated array
    }));
  };
  const handleBack = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index)); // Toggle behavior
  };
  return (
    <div className="template-style-container">
      <div className="style-container">
        <div className="style-box">
          {/* <div>
            <p style={{ marginLeft: '20px', fontSize: '19px' }}>{t('header')}</p>
          </div> */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginLeft: '10px',
              gap: '10px',
            }}
          >
            <p
              style={{
                width: '80%',
                margin: '0px 0px 0px 8px',
                fontSize: '15px',
                color: 'gray',
                display: 'flex',
                justifyContent: 'space-between',
                gap: '10px',
              }}
            >
              {t('menuTitle')}
              <div
                className="backIcon"
                style={{
                  paddingLeft: '60px',
                  transform: openIndex === 1 ? 'scaleY(-1)' : 'scaleY(1)',
                  transition: 'transform 0.3s ease',
                }}
                onClick={() => handleBack(1)}
                role="none"
              >
                <Accordion />
              </div>
            </p>
            {openIndex === 1 && (
              <div className="toggle">
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    {/* <p className="sub-title">
                      {t('Font Style')}
                    </p> */}
                    {/* <select
                      className="selectBox"
                      id="fontSelector"
                      value={selectedMtFont}
                      onChange={handleMtFamilyChange}
                    >
                      <option value="">{t('select a font')}</option>
                      {getFontStyles(template?.template_number).map((font) => (
                        <option style={{ fontFamily: font }} key={font} value={font}>{font}</option>
                      ))}
                    </select> */}
                    <SelectBoxNew
                      name="fontSelector"
                      id="fontSelector"
                      label={t('Font Style')}
                      placeholder={t('Select a font')}
                      value={selectedMtFont}
                      lists={getFontStyles(template?.template_number).map((font) => ({ id: font, label: font }))}
                      onchange={(name, selectedOption) => handleMtFamilyChange(selectedOption)}
                      required={false}
                    />
                  </div>
                  <div className="font-size-color-container" style={{ display: 'flex', alignItems: 'center' }}>
                    <div>
                      {/* <p className="sub-title">
                        {t('Font Size')}
                      </p> */}
                      {/* <select
                        className="selectBox"
                        id="fontSizeSelector"
                        value={selectedMtSize}
                        // style={{ margin: '3px 0px 0px 50px', border: 'none', outline: 'none' }}
                        onChange={handleMtSizeChange}
                      >
                        <option value="">{t('selectSize')}</option>
                        <option value="15px">very small</option>
                        <option value="20px">small</option>
                        <option value="30px">medium</option>
                        <option value="40px">large</option>
                        {template.template_number === 2 && (
                          <option value="100px">Very Large</option>
                        )}
                      </select> */}
                      <SelectBoxNew
                        name="fontSizeSelector"
                        label={t('Font Size')}
                        id="fontSizeSelector"
                        placeholder={t('Select Size')}
                        value={selectedMtSize}
                        lists={[
                          { id: '15px', label: 'very small' },
                          { id: '20px', label: 'small' },
                          { id: '30px', label: 'medium' },
                          { id: '40px', label: 'large' },
                          ...(template?.template_number === 2 ? [{ id: '100px', label: 'Very Large' }] : []),
                        ]}
                        onchange={(name, selectedOption) => handleMtSizeChange(selectedOption)}
                        required={false}
                      />
                    </div>
                    <div
                      style={{
                        margin: '30px 0px 0px 20px',
                        width: '30px',
                        height: '20px',
                        border: '1px solid gray',
                        borderRadius: '2px',
                        backgroundColor: MenuTitleColor,
                        cursor: 'pointer',
                      }}
                      onClick={handleMenuTitleDivClick}
                      role="none"
                    />
                  </div>
                  {isMenuTitleOpen && (
                    <div
                      style={{
                        position: 'absolute',
                        top: '150px',
                        left: '500px',
                        zIndex: 1,
                      }}
                    >
                      <SketchPicker color={MenuTitleColor} onChange={handleMenuTitleColorChange} />
                      <p className="closeButton" onClick={handleBlur} role="none">close</p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginLeft: '10px',
              gap: '10px',
            }}
          >
            <p
              style={
                {
                  width: '80%',
                  margin: '5% 0px 0px 8px',
                  fontSize: '15px',
                  justifyContent: 'space-between',
                  color: 'gray',
                  display: 'flex',
                  gap: '10px',
                }
              }
            >
              {t('menuSubtitle')}
              <div
                className="backIcon"
                style={{
                  paddingLeft: '33px',
                  transform: openIndex === 2 ? 'scaleY(-1)' : 'scaleY(1)',
                  transition: 'transform 0.3s ease',
                }}
                onClick={() => handleBack(2)}
                role="none"
              >
                <Accordion />
              </div>
            </p>
            {openIndex === 2 && (
              <div className="toggle" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                  {/* <p className="sub-title">
                    {t('Font Style')}
                  </p> */}
                  {/* <select
                    className="selectBox"
                    id="fontSelector"
                    value={selectedMstFont}
                    onChange={handleMstFamilyChange}
                  >
                    <option value="">{t('select a font')}</option>
                    {getFontStyles(template?.template_number)?.map((font) => (
                      <option style={{ fontFamily: font }} key={font} value={font}>{font}</option>
                    ))}
                  </select> */}
                  <SelectBoxNew
                    name="fontSelector"
                    label={t('Font Style')}
                    id="fontSelector"
                    placeholder={t('Select a font')}
                    value={selectedMstFont}
                    lists={getFontStyles(template?.template_number)?.map((font) => ({ id: font, label: font }))}
                    onchange={(name, selectedOption) => handleMstFamilyChange(selectedOption)}
                    required={false}
                  />
                </div>
                <div className="font-size-color-container" style={{ display: 'flex', alignItems: 'center' }}>
                  <div>
                    {/* <p className="sub-title">
                      {t('Font Size')}
                    </p> */}
                    {/* <select
                      id="fontSizeSelector"
                      value={selectedMstSize}
                      className="selectBox"
                      onChange={handleMstSizeChange}
                    >
                      <option value="">{t('selectSize')}</option>
                      <option value="15px">very small</option>
                      <option value="20px">Small</option>
                      <option value="30px">Medium</option>
                      <option value={template.template_number === 2 ? '65px' : '40px'}>
                        Large
                      </option>
                    </select> */}
                    <SelectBoxNew
                      name="fontSizeSelector"
                      id="fontSizeSelector"
                      label={t('Font Size')}
                      placeholder={t('Select Size')}
                      value={selectedMstSize}
                      lists={[
                        { id: '15px', label: 'very small' },
                        { id: '20px', label: 'Small' },
                        { id: '30px', label: 'Medium' },
                        {
                          id: template.template_number === 2 ? '65px' : '40px',
                          label: 'Large',
                        },
                      ]}
                      onchange={(name, selectedOption) => handleMstSizeChange(selectedOption)}
                      required={false}
                    />
                  </div>
                  <div>
                    <div
                      style={{
                        margin: '30px 0px 0px 20px',
                        width: '30px',
                        height: '20px',
                        border: '1px solid gray',
                        borderRadius: '2px',
                        backgroundColor: MstColor,
                        cursor: 'pointer',
                      }}
                      onClick={handleMstDivClick}
                      role="none"
                    />
                    {isMstOpen && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '150px',
                          left: '500px',
                          zIndex: 1,
                        }}
                      >
                        <SketchPicker color={MstColor} onChange={handleMstColorChange} />
                        <p className="closeButton" onClick={handleColorMst} role="none">close</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* <div style={{ margin: '10px 0px 0px 0px', border: '0.75px solid #CED0D3', width: '24vw' }} /> */}
          {/* <p style={{ marginLeft: '20px', fontSize: '19px' }}>{t('listItems')}</p> */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginLeft: '10px',
              gap: '10px',
            }}
          >
            <p
              style={
                {
                  width: '80%',
                  margin: '5% 0px 0px 8px',
                  fontSize: '15px',
                  color: 'gray',
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '10px',
                }
              }
            >
              {t('categoryMenu')}
              <div
                className="backIcon"
                style={{
                  paddingLeft: '26px',
                  transform: openIndex === 3 ? 'scaleY(-1)' : 'scaleY(1)',
                  transition: 'transform 0.3s ease',
                }}
                onClick={() => handleBack(3)}
                role="none"
              >
                <Accordion />
              </div>
            </p>
            {openIndex === 3 && (
              <div className="toggle" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                  {/* <p className="sub-title">
                    {t('Font Style')}
                  </p> */}
                  {/* <select
                    // style={{ margin: '20px 0px 0px 50px', border: 'none', outline: 'none' }}
                    className="selectBox"
                    id="fontSelector"
                    value={selectedCmFont}
                    onChange={handleCmFamilyChange}
                  >
                    <option value="">{t('select a font')}</option>
                    {getFontStyles(template?.template_number)?.map((font) => (
                      <option style={{ fontFamily: font }} key={font} value={font}>{font}</option>
                    ))}
                  </select> */}
                  <SelectBoxNew
                    name="fontSelector"
                    id="fontSelector"
                    label={t('Font Style')}
                    placeholder={t('Select a Font')}
                    value={selectedCmFont}
                    lists={getFontStyles(template?.template_number)?.map((font) => ({
                      id: font,
                      label: font,
                    }))}
                    onchange={(name, selectedOption) => handleCmFamilyChange(selectedOption)}
                    required={false}
                  />
                </div>
                <div className="font-size-color-container" style={{ display: 'flex', alignItems: 'center' }}>
                  <div>
                    {/* <p className="sub-title">
                      {t('Font Size')}
                    </p> */}
                    {/* <select
                      id="fontSizeSelector"
                      value={selectedCmSize}
                      className="selectBox"
                      // style={{ margin: '20px 0px 0px 50px', border: 'none', outline: 'none' }}
                      onChange={handleCmSizeChange}
                    >
                      <option value="">{t('selectSize')}</option>
                      <option value="15px">very small</option>
                      <option value="20px">Small</option>
                      <option value="30px">Medium</option>
                      <option value="40px">Large</option>
                    </select> */}
                    <SelectBoxNew
                      name="fontSizeSelector"
                      id="fontSizeSelector"
                      label={t('Font Size')}
                      placeholder={t('Select Size')}
                      value={selectedCmSize}
                      lists={[
                        { id: '15px', label: 'Very Small' },
                        { id: '20px', label: 'Small' },
                        { id: '30px', label: 'Medium' },
                        { id: '40px', label: 'Large' },
                      ]}
                      onchange={(name, selectedOption) => handleCmSizeChange(selectedOption)}
                      required={false}
                    />
                  </div>
                  <div>
                    <div
                      style={{
                        margin: '30px 0px 0px 20px',
                        width: '30px',
                        height: '20px',
                        border: '1px solid gray',
                        borderRadius: '2px',
                        backgroundColor: CmColor,
                        cursor: 'pointer',
                      }}
                      onClick={handleCmDivClick}
                      role="none"
                    />
                    {isCmOpen && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '150px',
                          left: '500px',
                          zIndex: 1,
                        }}
                      >
                        <SketchPicker color={CmColor} onChange={handleCmColorChange} />
                        <p className="closeButton" onClick={handleColorCm} role="none">close</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginLeft: '10px',
              gap: '10px',
            }}
          >
            <p
              style={
                {
                  width: '80%',
                  margin: '5% 0px 0px 8px',
                  fontSize: '15px',
                  color: 'gray',
                  justifyContent: 'space-between',
                  display: 'flex',
                  gap: '10px',
                }
              }
            >
              {t('item name')}
              <div
                className="backIcon"
                style={{
                  paddingLeft: '60px',
                  transform: openIndex === 4 ? 'scaleY(-1)' : 'scaleY(1)',
                  transition: 'transform 0.3s ease',
                }}
                onClick={() => handleBack(4)}
                role="none"
              >
                <Accordion />
              </div>
            </p>
            {openIndex === 4 && (
              <div className="toggle" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                  {/* <p className="sub-title">
                    {t('Font Style')}
                  </p> */}
                  {/* <select
                    // style={{ margin: '20px 0px 0px 50px', border: 'none', outline: 'none' }}
                    className="selectBox"
                    id="fontSelector"
                    value={selectedInFont}
                    onChange={handleInFamilyChange}
                  >
                    <option value="">{t('select a font')}</option>
                    {getFontStyles(template?.template_number)?.map((font) => (
                      <option style={{ fontFamily: font }} key={font} value={font}>{font}</option>
                    ))}
                  </select> */}
                  <SelectBoxNew
                    name="fontSelector"
                    id="fontSelector"
                    label={t('Font Style')}
                    placeholder={t('Select a Font')}
                    value={selectedInFont}
                    lists={getFontStyles(template?.template_number)?.map((font) => ({
                      id: font,
                      label: font,
                    }))}
                    onchange={(name, selectedOption) => handleInFamilyChange(selectedOption)}
                    required={false}
                  />
                </div>
                <div className="font-size-color-container" style={{ display: 'flex', alignItems: 'center' }}>
                  <div>
                    {/* <p className="sub-title">
                      {t('Font Size')}
                    </p> */}
                    {/* <select
                      id="fontSizeSelector"
                      value={selectedInSize}
                      className="selectBox"
                      // style={{ margin: '20px 0px 0px 50px', border: 'none', outline: 'none' }}
                      onChange={handleInSizeChange}
                    >
                      <option value="">{t('selectSize')}</option>
                      <option value="15px">very small</option>
                      <option value="20px">Small</option>
                      <option value="30px">Medium</option>
                      <option value="40px">Large</option>
                    </select> */}
                    <SelectBoxNew
                      name="fontSizeSelector"
                      id="fontSizeSelector"
                      label={t('Font Size')}
                      placeholder={t('Select Size')}
                      value={selectedInSize}
                      lists={[
                        { id: '15px', label: 'Very Small' },
                        { id: '20px', label: 'Small' },
                        { id: '30px', label: 'Medium' },
                        { id: '40px', label: 'Large' },
                      ]}
                      onchange={(name, selectedOption) => handleInSizeChange(selectedOption)}
                      required={false}
                    />
                  </div>
                  <div>
                    <div
                      style={{
                        margin: '30px 0px 0px 20px',
                        width: '30px',
                        height: '20px',
                        border: '1px solid gray',
                        borderRadius: '2px',
                        backgroundColor: InColor,
                        cursor: 'pointer',
                      }}
                      onClick={handleInDivClick}
                      role="none"
                    />
                    {isInOpen && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '150px',
                          left: '500px',
                          zIndex: 1,
                        }}
                      >
                        <SketchPicker color={InColor} onChange={handleInColorChange} />
                        <p className="closeButton" onClick={handleColorIn} role="none">close</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginLeft: '10px',
              gap: '10px',
            }}
          >
            <p
              style={
                {
                  width: '80%',
                  margin: '5% 0px 0px 8px',
                  fontSize: '15px',
                  justifyContent: 'space-between',
                  color: 'gray',
                  display: 'flex',
                  gap: '10px',
                }
              }
            >
              {t('itemDescription')}
              <div
                className="backIcon"
                style={{
                  paddingLeft: '18px',
                  transform: openIndex === 5 ? 'scaleY(-1)' : 'scaleY(1)',
                  transition: 'transform 0.3s ease',
                }}
                onClick={() => handleBack(5)}
                role="none"
              >
                <Accordion />
              </div>
            </p>
            {openIndex === 5 && (
              <div className="toggle" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                  {/* <p className="sub-title">
                    {t('Font Style')}
                  </p> */}
                  {/* <select
                    // style={{ margin: '20px 0px 0px 50px', border: 'none', outline: 'none' }}
                    id="fontSelector"
                    className="selectBox"
                    value={selectedIdFont}
                    onChange={handleIdFamilyChange}
                  >

                    <option value="">{t('select a font')}</option>
                    {getFontStyles(template?.template_number)?.map((font) => (
                      <option style={{ fontFamily: font }} key={font} value={font}>{font}</option>
                    ))}
                  </select> */}
                  <SelectBoxNew
                    name="fontSelector"
                    id="fontSelector"
                    label={t('Font Style')}
                    placeholder={t('Select a Font')}
                    value={selectedIdFont}
                    lists={getFontStyles(template?.template_number)?.map((font) => ({
                      id: font,
                      label: font,
                    })) || []}
                    onchange={(name, selectedOption) => handleIdFamilyChange(selectedOption)}
                    required={false}
                  />
                </div>
                <div className="font-size-color-container" style={{ display: 'flex', alignItems: 'center' }}>
                  <div>
                    {/* <p className="sub-title">
                      {t('Font Size')}
                    </p> */}
                    {/* <select
                      id="fontSizeSelector"
                      value={selectedIdSize}
                      className="selectBox"
                      // style={{ margin: '20px 0px 0px 50px', border: 'none', outline: 'none' }}
                      onChange={handleIdSizeChange}
                    >
                      <option value="">{t('selectSize')}</option>
                      <option value="15px">very small</option>
                      <option value="20px">Small</option>
                      <option value="30px">Medium</option>
                      <option value="40px">Large</option>
                    </select> */}
                    <SelectBoxNew
                      name="fontSizeSelector"
                      id="fontSizeSelector"
                      label={t('Font Size')}
                      placeholder={t('Select Size')}
                      value={selectedIdSize}
                      lists={[
                        { id: '15px', label: t('Very Small') },
                        { id: '20px', label: t('Small') },
                        { id: '30px', label: t('Medium') },
                        { id: '40px', label: t('Large') },
                      ]}
                      onchange={(name, selectedOption) => handleIdSizeChange(selectedOption)}
                      required={false}
                    />
                  </div>
                  <div>
                    <div
                      style={{
                        margin: '30px 0px 0px 20px',
                        width: '30px',
                        height: '20px',
                        border: '1px solid gray',
                        borderRadius: '2px',
                        backgroundColor: IdColor,
                        cursor: 'pointer',
                      }}
                      onClick={handleIdDivClick}
                      role="none"
                    />
                    {isIdOpen && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '150px',
                          left: '500px',
                          zIndex: 1,
                        }}
                      >
                        <SketchPicker color={IdColor} onChange={handleIdColorChange} />
                        <p className="closeButton" onClick={handleColorId} role="none">close</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginLeft: '10px',
              gap: '10px',
            }}
          >
            <p
              style={
                {
                  width: '80%',
                  margin: '5% 0px 0px 8px',
                  fontSize: '15px',
                  justifyContent: 'space-between',
                  color: 'gray',
                  display: 'flex',
                  gap: '10px',
                }
              }
            >
              {t('itemPriceHeaders')}
              <div
                className="backIcon"
                onClick={() => handleBack(6)}
                style={{
                  transform: openIndex === 6 ? 'scaleY(-1)' : 'scaleY(1)',
                  transition: 'transform 0.3s ease',
                }}
                role="none"
              >
                <Accordion />
              </div>
            </p>
            {openIndex === 6 && (
              <div className="toggle" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                  {/* <p className="sub-title">
                    {t('Font Style')}
                  </p> */}
                  {/* <select
                    // style={{ margin: '20px 0px 0px 50px', border: 'none', outline: 'none' }}
                    id="fontSelector"
                    className="selectBox"
                    value={selectedIphFont}
                    onChange={handleIphFamilyChange}
                  >
                    <option value="">{t('select a font')}</option>
                    {getFontStyles(template?.template_number)?.map((font) => (
                      <option style={{ fontFamily: font }} key={font} value={font}>{font}</option>
                    ))}
                  </select> */}
                  <SelectBoxNew
                    name="fontSelector"
                    id="fontSelector"
                    label={t('Font Style')}
                    placeholder={t('Select a Font')}
                    value={selectedIphFont}
                    lists={getFontStyles(template?.template_number)?.map((font) => ({
                      id: font,
                      label: font,
                    }))}
                    onchange={(name, selectedOption) => handleIphFamilyChange(selectedOption)}
                    required={false}
                  />
                </div>
                <div className="font-size-color-container" style={{ display: 'flex', alignItems: 'center' }}>
                  <div>
                    {/* <p className="sub-title">
                      {t('Font Size')}
                    </p> */}
                    {/* <select
                      id="fontSizeSelector"
                      value={selectedIphSize}
                      // style={{ margin: '20px 0px 0px 50px', border: 'none', outline: 'none' }}
                      className="selectBox"
                      onChange={handleIphSizeChange}
                    >
                      <option value="">{t('selectSize')}</option>
                      <option value="15px">very small</option>
                      <option value="20px">Small</option>
                      <option value="30px">Medium</option>
                      <option value="40px">Large</option>
                    </select> */}
                    <SelectBoxNew
                      name="fontSizeSelector"
                      id="fontSizeSelector"
                      label={t('Font Size')}
                      placeholder={t('Select Size')}
                      value={selectedIphSize}
                      lists={[
                        { id: '15px', label: 'Very Small' },
                        { id: '20px', label: 'Small' },
                        { id: '30px', label: 'Medium' },
                        { id: '40px', label: 'Large' },
                      ]}
                      onchange={(name, selectedOption) => handleIphSizeChange(selectedOption)}
                      required={false}
                    />
                  </div>
                  <div>
                    <div
                      style={{
                        margin: '30px 0px 0px 20px',
                        width: '30px',
                        height: '20px',
                        border: '1px solid gray',
                        borderRadius: '2px',
                        backgroundColor: IphColor,
                        cursor: 'pointer',
                      }}
                      onClick={handleIphDivClick}
                      role="none"
                    />
                    {isIphOpen && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '150px',
                          left: '500px',
                          zIndex: 1,
                        }}
                      >
                        <SketchPicker color={IphColor} onChange={handleIphColorChange} />
                        <p className="closeButton" onClick={handleColorIph} role="none">close</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginLeft: '10px',
              gap: '10px',
            }}
          >
            <p
              style={
                {
                  width: '80%',
                  margin: '5% 0px 0px 8px',
                  fontSize: '15px',
                  justifyContent: 'space-between',
                  color: 'gray',
                  display: 'flex',
                  gap: '10px',
                }
              }
            >
              {t('itemPrice')}
              <div
                className="backIcon"
                style={{
                  paddingLeft: '62px',
                  transform: openIndex === 7 ? 'scaleY(-1)' : 'scaleY(1)',
                  transition: 'transform 0.3s ease',
                }}
                onClick={() => handleBack(7)}
                role="none"
              >
                <Accordion />
              </div>
            </p>
            {openIndex === 7 && (
              <div className="toggle" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                  {/* <p className="sub-title">
                    {t('Font Style')}
                  </p> */}
                  {/* <select
                    // style={{ margin: '20px 0px 0px 50px', border: 'none', outline: 'none' }}
                    id="fontSelector"
                    className="selectBox"
                    value={selectedIpFont}
                    onChange={handleIpFamilyChange}
                  >
                    <option value="">{t('select a font')}</option>
                    {getFontStyles(template?.template_number)?.map((font) => (
                      <option style={{ fontFamily: font }} key={font} value={font}>{font}</option>
                    ))}
                  </select> */}
                  <SelectBoxNew
                    name="fontSelector"
                    id="fontSelector"
                    label={t('Font Style')}
                    placeholder={t('Select a Font')}
                    value={selectedIpFont}
                    lists={getFontStyles(template?.template_number)?.map((font) => ({
                      id: font,
                      label: font,
                    }))}
                    onchange={(name, selectedOption) => handleIpFamilyChange(selectedOption)}
                    required={false}
                  />
                </div>
                <div className="font-size-color-container" style={{ display: 'flex', alignItems: 'center' }}>
                  <div>
                    {/* <p className="sub-title">
                      {t('Font Size')}
                    </p> */}
                    {/* <select
                      id="fontSizeSelector"
                      value={selectedIpSize}
                      className="selectBox"
                      // style={{ margin: '20px 0px 0px 50px', border: 'none', outline: 'none' }}
                      onChange={handleIpSizeChange}
                    >
                      <option value="">{t('selectSize')}</option>
                      <option value="15px">very small</option>
                      <option value="20px">Small</option>
                      <option value="30px">Medium</option>
                      <option value="40px">Large</option>
                    </select> */}
                    <SelectBoxNew
                      name="fontSizeSelector"
                      id="fontSizeSelector"
                      label={t('Font Size')}
                      placeholder={t('Select Size')}
                      value={selectedIpSize}
                      lists={[
                        { id: '15px', label: 'Very Small' },
                        { id: '20px', label: 'Small' },
                        { id: '30px', label: 'Medium' },
                        { id: '40px', label: 'Large' },
                      ]}
                      onchange={(name, selectedOption) => handleIpSizeChange(selectedOption)}
                      required={false}
                    />
                  </div>
                  <div>
                    <div
                      style={{
                        margin: '30px 0px 0px 20px',
                        width: '30px',
                        height: '20px',
                        border: '1px solid gray',
                        backgroundColor: IpColor,
                        cursor: 'pointer',
                      }}
                      onClick={handleIpDivClick}
                      role="none"
                    />
                    {isIpOpen && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '150px',
                          left: '500px',
                          zIndex: 1,
                        }}
                      >
                        <SketchPicker color={IpColor} onChange={handleIpColorChange} />
                        <p className="closeButton" onClick={handleColorIp} role="none">close</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* <div style={{ margin: '10px 0px 0px 0px', border: '0.75px solid #CED0D3', width: '24vw' }} /> */}
          {arr?.template_images?.length > 0 && (
            <div style={{ marginBottom: '10px' }}>
              <p
                style={{
                  width: '80%',
                  margin: '1px 0px 0px 20px',
                  fontSize: '15px',
                  fontWeight: '600',
                  color: '#101928',
                  display: 'flex',
                }}
              >{t('Template Images')}
              </p>
            </div>
          )}
          {arr?.template_images?.length > 0 && arr?.template_images?.map((image, imgIndex) => (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                margin: '10px 0 0 20px',
                borderRadius: '3px',
                border: '0.75px solid #E4E7EC',
                background: '#F9FAFB',
                justifyContent: 'space-around',
                width: '230px',
                height: '100px',
              }}
              key={image}
            >
              <div style={{ width: '100px', height: '50px' }}>
                {loading === imgIndex
                  ? (
                    <div style={{ display: 'grid', placeItems: 'center' }}>
                      <CircularProgress color="success" />
                    </div>
                  )
                  : (
                    image?.image !== null && (
                      <img
                        src={image?.image}
                        alt="background"
                        loading="lazy"
                      />
                    )
                  )}
              </div>
              <div>
                <input
                  type="file"
                  ref={imageRefs?.[imgIndex]}
                  accept="image/*"
                  id={`fileInput-${imgIndex}`}
                  onChange={(e) => handleFileChange(e, imgIndex)}
                  style={{ display: 'none' }}
                />
                <button
                  type="button"
                  style={{ margin: '0px 0px 0px 50px', border: 'none' }}
                  onClick={(e) => handleChangeBackgroundImage(e, imgIndex)}
                >
                  {/* {image?.image === null ? 'Add-image' : 'Replace'} */}
                  {image?.image === null ? <PlusIcon /> : <EditTemplateIcon />}
                </button>
                {image?.image !== null && (
                  <div
                    className="icon"
                    role="none"
                    style={{ margin: '0px 0px 0px 50px', border: 'none' }}
                    onClick={() => removeBackgroundImage(imgIndex)}
                  >
                    <DeleteTemplateIcon />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

StyleTemplateEditor.propTypes = {
  setNewData: PropTypes.objectOf().isRequired,
  // Ensure templateData is an array of objects with specific shape
};

export default StyleTemplateEditor;
